import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Chat } from '../Chat'

@InputType()
export class UpdateChatTagsArgs extends ActionArgs {
  @Field(() => ID)
  chatId: string

  @Field(() => [String])
  tags: string[]
}

export interface IUpdateChatTags extends IAction<Chat, UpdateChatTagsArgs> {}
